import React from 'react';
import { Globe, ShieldOff } from 'lucide-react';

export default function AccessRestricted() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-950 flex items-center justify-center p-6" data-testid="access-restricted-page">
      <div className="max-w-lg w-full bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-10 text-center shadow-2xl">
        <div className="mx-auto w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mb-6">
          <ShieldOff className="w-10 h-10 text-red-400" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-3">Access Denied</h1>
        <p className="text-slate-300 mb-8">
          For security purposes, access to Acacia Insurance is not permitted from your location.
        </p>
        <div className="flex items-center justify-center gap-2 text-slate-400 text-sm">
          <Globe className="w-4 h-4" />
          <span>If you believe this is an error, contact your system administrator.</span>
        </div>
      </div>
    </div>
  );
}
